import { render, staticRenderFns } from "./orderPie.vue?vue&type=template&id=4b5ef540&scoped=true&"
import script from "./orderPie.vue?vue&type=script&lang=js&"
export * from "./orderPie.vue?vue&type=script&lang=js&"
import style0 from "./orderPie.vue?vue&type=style&index=0&id=4b5ef540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ef540",
  null
  
)

export default component.exports